import React from "react";
import { css, Theme, useTheme } from "@emotion/react";

import WrapperFromCore from "core/Components/Wrapper";

type Props = {
    children: React.ReactNode,
    className?: string,
    topBannerHeight: number,
    isUsingAltDesign: boolean,
};

const Wrapper: React.FC<Props> = ({ children, className = "", topBannerHeight, isUsingAltDesign }) => {
    const theme: Theme = useTheme();

    const wrapperStyle = css`
        position: relative;
        justify-content: flex-start;
        height: ${topBannerHeight}px;
        padding: 0 93px;
        
        ${theme.breakpoints.up("5xl")} {
            padding: 0 ${isUsingAltDesign ? 240 : 122 }px;
        }

        ${theme.breakpoints.between("3xl", "4xl")} {
            padding: 0 ${isUsingAltDesign ? 240 : 80 }px;
        }

        ${theme.breakpoints.only("xl")} {
            padding: 0 ${isUsingAltDesign ? 160 : 80 }px;
        }

        ${theme.breakpoints.only("lg")} {
            padding: 0 ${isUsingAltDesign ? 80 : 42 }px;
        }

        ${theme.breakpoints.only("md")} {
            padding: 0 71px;
        }

        ${theme.breakpoints.only("sm")} {
            padding: 0 45px;
        }

        ${theme.breakpoints.down("xs")} {
            padding: 0 25px;
        }
    `;

    return (
        <WrapperFromCore css={wrapperStyle} useMaxWidth={false} useMinHeight={false} className={className}>
            {children}
        </WrapperFromCore>
    );
}

export default Wrapper;
